module.exports = __webpack_public_path__ + "static/media/car.6133e480.svg";